import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { LoadableFallback } from 'components/Common/LoadableFallback';

const MyDetails = loadable(() => import(/* webpackChunkName: "MyDetails" */ './MyDetails'), {
  fallback: <LoadableFallback visible />,
});

const asyncMyDetails = ({ route }) => (
  <MyDetails route={route} />
);

asyncMyDetails.propTypes = {
  route: PropTypes.object.isRequired,
};

export default asyncMyDetails;
